import { GatsbyLinkProps, Link } from 'gatsby';
import React from 'react';

interface LinkButtonProps extends Omit<GatsbyLinkProps<{}>, 'ref'> {
  to: string;
  variant?: 'primary' | 'secondary' | 'dark';
  size?: 'sm' | 'md' | 'lg' | 'full';
  disabled?: boolean;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  children,
  to,
  variant = 'primary',
  size = 'md',
  disabled = false,
  ...props
}) => {
  const baseStyle = 'inline-block rounded-lg focus:outline-none focus:ring-0';

  const variants = {
    primary: 'bg-dark-100 text-white border border-gray-50 hover:bg-white hover:text-dark-100',
    secondary: 'bg-gray-5 text-dark-50 border border-gray-5 hover:border-gray-60 hover:bg-dark-100 hover:text-white',
    dark: 'bg-dark border border-dark text-white hover:bg-red-600 focus:ring-red-500',
  };

  const sizes = {
    sm: 'px-4 py-1 text-base',
    md: 'px-4 py-2 text-base',
    lg: 'px-6 py-3 text-lg',
    full: 'px-6 w-full py-3 text-base',
  };

  const classes = `
    ${baseStyle} 
    ${variants[variant]} 
    ${sizes[size]} 
    ${disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'hover:shadow-md'}
  `;

  return (
    <Link
      to={disabled ? "#" : to}
      className={classes}
      {...props}
    >
      {children}
    </Link>
  );
};

export default LinkButton;
